define([
    "./occurrenceStatusModule",
    "./occurrenceStatusRouter",
    "./search/OccurrenceStatusSearchController",
    "./edition/OccurrenceStatusEditionController",
    "./occurrenceStatusService"
], function () {
});